import { Transformation } from "./Transformation.js";
/**
 * @summary SDK
 * @extends {SDK.Transformation}
 * @memberOf SDK
 */
class VideoTransformation extends Transformation {
}
export { VideoTransformation };
